export { default } from "@ember/render-modifiers/modifiers/will-destroy";
